export default "__VITE_ASSET__DQKyVsL5__"